import { Backdrop, Button, Card, CircularProgress, Typography } from "@mui/material";
import PageHeader from "../../common/page-header";
import { useState } from "react";
import { Employee } from "../../../../api/Endpoints/Employee";
import { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import BasicTabs from "./DetailTabMenus";
import CreateEmployeeTabs from "./ViewCreateEmployeeTabs";
const Pages = () => {

    const columns = [

        {
            field: 'name', headerName: 'Name', width: 300, renderCell: (params) => (
                <>
                    <Typography sx={{ color: 'blue' }} 
                    // onClick={() => { ViewTabs(params.row.employee_id) }}
                    >{params.value}</Typography>
                </>
            )
        },

        { field: 'email', headerName: 'Email', width: 300, renderCell: (params) => <>{params.value}</> },


        { field: 'role', headerName: 'ROLE', width: 300, renderCell: (params) => <>{params.value}</> },

        {
            field: 'edit',
            headerName: 'Edit',

            width: 100,
            renderCell: (params) => (
                <>
                    <Button varient='contained' size='small' onClick={() => handleEdit(params.row.employee_id)}>Edit</Button>
                </>
            )
        }


    ]

    const [refresh, setRefresh] = useState(false)
    const [editId, setEditId] = useState()
    const [CreateEmployeeTab, setCreateEmployeeTab] = useState(false)
    const [Tabs, setTabs] = useState(false)
    const [pageNumber, setPageNumber] = useState(0);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ID, setID] = useState(0)

    // const handleCreate = () => {
    //     setEditId(0)
    //     setRefresh(Math.random)
    // }
    const handleUpdate = () => {
        setPageNumber();
        setPageNumber(0);
    }
    const handleEdit = (id) => {
        setRefresh(Math.random);
        setEditId(parseInt(id));
    }

    const ViewTabs = (id) => {
        setID(id)
        setTabs(true)
    }


    const handlePageChange = (page) => {
        setPageNumber(page)
    }


    useEffect(() => {
        fetchTable();
    }, [pageNumber])



    const fetchTable = () => {
        setLoading(true);
        Employee.get({ page: Number(pageNumber) + 1 }).then(response => {
            setList(response.data.data);
            setLoading(false);
        })
    }


    return (

        <>
            {Tabs ? (<BasicTabs setTabs={setTabs} ID={ID} />
            ) : (
                <>

                    <Card sx={{ p: 1, display: "flex", justifyContent: "space-between", mb: 1, mt: 1, boxShadow: 0, backgroundColor: 'transparent' }} >
                        <PageHeader title={"Pages"} />
                        {/* <CreateEmployeeTabs
                            key={refresh}
                            // onNew={handleCreate}
                            onUpdate={handleUpdate}
                            editId={editId}
                            setEditId={setEditId}
                            setCreateEmployeeTabs={setCreateEmployeeTab}
                            CreateEmployeeTabs={CreateEmployeeTab} /> */}

                    </Card >
                    <Card sx={{ m: 2 }} variant="outlined">
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={loading}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                        {typeof list.data === "object" &&
                            <DataGrid
                                paginationMode="server"
                                rows={list?.data}
                                columns={columns}
                                page={pageNumber}
                                pageSize={10}
                                rowHeight={30}
                                rowsPerPageOptions={[10]}
                                rowCount={list.total}
                                onPageChange={handlePageChange}
                                autoHeight
                                density={"comfortable"}
                            />
                        }
                    </Card>
                </>
            )}
        </>

    )
};

export default Pages;
